import {
    actionFailure,
    createActionHandler,
} from 'src/modules/assistant/actions/createActionHandler';
import { TReplyWhatsappDraft } from 'src/modules/assistant/actions/types';
import { hasRequiredDocuments } from 'src/modules/assistant/helpers/hasRequiredDocuments';
import { getLeadStoreArea } from 'src/modules/assistant/helpers/getLeadStoreArea';
import { isChannelsModeArea } from 'src/modules/conversations/channels';
import { sendChannelReply } from './sendChannelReply';
import { sendLegacyReply } from './sendLegacyReply';

export const replyWhatsapp = createActionHandler<TReplyWhatsappDraft>({
    fields: [['message', 'Assistant.ActionFieldMessage', true]],
    acceptsDocuments: true,
    validate: (draft) =>
        Boolean(draft.message?.trim()) && hasRequiredDocuments(draft),
    execute: (draft, deps) => {
        if (!deps.channel.canSendFreeForm)
            return actionFailure(deps.channel.freeFormBlockReason);
        const send = isChannelsModeArea(getLeadStoreArea(deps.lead))
            ? sendChannelReply
            : sendLegacyReply;
        return send(draft, deps);
    },
});
